import { cn } from '../../utils/cn';

const GROUP_DOT = {
  needs: 'bg-group-needs',
  wants: 'bg-group-wants',
  savings: 'bg-group-savings',
  debt: 'bg-group-debt',
  'custom-1': 'bg-group-custom-1',
  'custom-2': 'bg-group-custom-2',
};

const STATUS_TONE = {
  success: 'bg-success-50 text-success-700 dark:bg-success-700/20 dark:text-success-500',
  warning: 'bg-warning-50 text-warning-700 dark:bg-warning-700/20 dark:text-warning-500',
  danger: 'bg-danger-50 text-danger-700 dark:bg-danger-700/20 dark:text-danger-500',
  info: 'bg-info-50 text-info-700 dark:bg-info-700/20 dark:text-info-500',
  sage: 'bg-sage-tint text-sage-on-tint',
};

const chipClassName =
  'inline-flex items-center gap-space-1 rounded-ds-full bg-stone-100 px-space-2 py-space-1 text-type-chip text-foreground dark:bg-stone-800';

const pillClassName = 'inline-flex items-center gap-space-1 rounded-ds-full px-space-2 py-space-1 text-type-chip';

/**
 * Badge de categoria (chip com ponto colorido pelo grupo) ou de estado.
 * Alinhado à anotação `ds/badge` do .pen.
 *
 * @param {{ category?: 'needs'|'wants'|'savings'|'debt'|'custom-1'|'custom-2', status?: 'success'|'warning'|'danger'|'info'|'sage', className?: string, children: React.ReactNode }} props
 */
export function Badge({ category, status, className, children }) {
  const tone = status && STATUS_TONE[status];

  if (tone) {
    return (
      <span
        data-ds-id={`ds/badge/status--${status}`}
        className={cn(pillClassName, tone, className)}
      >
        {children}
      </span>
    );
  }

  const groupDot = category && GROUP_DOT[category];
  return (
    <span
      data-ds-id={`ds/badge/category--group-${category ?? 'custom-1'}`}
      className={cn(chipClassName, className)}
    >
      {groupDot ? <span className={cn('size-2 shrink-0 rounded-ds-full', groupDot)} aria-hidden /> : null}
      {children}
    </span>
  );
}

export default Badge;
